export const prop_sx_cpSPresentDocs={
 caProxy_not: 'caProxy_not',
 caProxy: 'caProxy'
}
export function buildFormItem(item) {
 const {prop_sx_cpSPresentDoc}=this.state;
 if(['prop_sx_cpSPresentDocDate','prop_sx_cpSPresentDocExpire'].indexOf(item.Name) !== -1) item.Required=prop_sx_cpSPresentDoc===prop_sx_cpSPresentDocs.caProxy;
 return item;
}